import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';

import pngLogo from 'media/pngLogo.png';

import theme from './theme.module.scss';

interface TabItem {
  key: string;
  label: string;
  route: string;
  icon?: string;
  exact?: boolean;
}

export default function Sidebar({ tabs }: { tabs: TabItem[] }) {
  const location = useLocation();

  return (
    <div className={theme.container}>
      <NavLink to="/" className={theme.logoContainer}>
        <img className={theme.logo} src={pngLogo} alt="PNG logo" height={48} />
        <span>Employee Directory</span>
      </NavLink>
      {tabs.map(tab => (
        <NavLink
          key={tab.key}
          to={tab.route}
          className={classNames(
            theme.tab,
            tab.exact
              ? location.pathname === tab.route
                ? theme.active
                : null
              : location.pathname === tab.route ||
                (location.pathname.startsWith(tab.route) && tab.route !== '/')
              ? theme.active
              : null
          )}
        >
          {tab.icon && <img src={tab.icon} alt={tab.label} width={20} height={20} />}
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}
